import React from "react"
import PropTypes from "prop-types"

class Collapser extends React.Component {
  static propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired
  }

  componentDidMount = () => {}

  render() {
    // eslint-disable-next-line react/prop-types
    const { isExpanded, handleClick, useLargerCheckbox } = this.props

    return (
      <span
        style={{ paddingRight: "5px"}}
        className={isExpanded ? (useLargerCheckbox ? "fa fa-minus-square-o fa-lg" : "fa fa-minus-square-o")  : (useLargerCheckbox ? "fa fa-plus-square-o fa-lg" : "fa fa-plus-square-o")}
        onClick={handleClick}
      />
    )
  }
}

Collapser.propTypes = {
  useLargerCheckbox: PropTypes.bool
}

Collapser.defaultProps = {
  useLargerCheckbox: false
}

export default Collapser



// WEBPACK FOOTER //
// ./src/components/layout/checkbox-tree/Collapser.jsx